
import { put, select, takeLatest } from 'redux-saga/effects';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/inPatientTypes';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { convertToISOStrings, formatSelectedFilter, prepareConfigForDisplayNameUpload, prepareConfigForUpload } from '../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../..';
import { INPATIENT_LIST_PAGERANGE, TAG_LIST_NAME, TPA_DB_TAG_LIST_CLAIM_VIEW, TPA_DB_TAG_LIST_NAME, TPA_DB_TAG_LIST_PRE_AUTH_VIEW } from '../../../shared/constants/crmConstants';
import { updateClaimsDisplayConfig, updateGrievanceConfig, updateIpConfig,
   updateIpConfigClaimViewConfig, updateIpConfigPreAuthViewConfig, updateReconciliationIpConfig, updateReportingConfig,
  updateTatReportingConfig } from '../../actions/applicationDetailAction';
import { ApplicationDetailModel } from '../../models/applicationDetailModel';
import { centeredNotification, combineDateAndTime, convertUtcToIst, filterDateFilterOnly } from '../../../utils/utility';
import { COMMON_ERROR, defaultPostParams, DEFAULT_DATE_FILTER, INPATIENT_DATA, PREFERENCE_SAVE_FAIL_ERR, tableConfigKeyMap } from '../../../shared/constants/commonConstants';
import { encryptText } from '../../../utils/encryptDecrypt';
import { setBadRequestCount, setFollowUpDetails, setTpaGlobalSearchClicked, setViewCounts } from '../../actions/inPatientAction';
import { isEmpty } from 'lodash';

function* fetchTagListCount({ payload }: any): Generator {
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const groupProviders = appDetail.getGroupProviders();
  const isNewTpaActiveForGroupProvider = appDetail?.getIsNewTpaActiveForGroupProvider() || false;
  const groupProvidersPresent = !isEmpty(groupProviders);

  if (process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true') {
    return yield fetchTpaTagListCount({ payload });
  } else if (process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'false' && (!groupProvidersPresent || isNewTpaActiveForGroupProvider)) {
    return yield fetchTpaTagListCount({ payload });
  }
  const { getTagListCount } = payload;
  const sendRequest = SendRequest.instance;
  const tagArr: any = [];
  TAG_LIST_NAME.map((item: any): any => {
    tagArr.push(item.id);
  });

  const tagListRequest: any = {
    providerId: appDetail.getProviderId(),
    nextStatusList: tagArr?.filter((ele: string): boolean => ele !== 'DRAFT'),
  };

  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.CRM_BASE_URL}/Provider/Search/HospitalStatusClaimCount`, tagListRequest,
      { isShowErrorInInterceptor: false });
    getTagListCount(response);
  } catch (e) {
    getTagListCount({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}

function* fetchTpaTagListCount({ payload }: any): Generator {
  const { getTpaTagListCount } = payload;
  const { filters, isPreAuthView, showTpaStartDateAndTime,
    showTpaEndDateAndTime }: any = yield select((state: RootState): any => state.selectedInPatientDetail);
    const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
    const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
    const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const { getTagFilterCount } = payload;
  const selectedList = (isPreAuthClaimViewEnabled) ?
   (isPreAuthView ? TPA_DB_TAG_LIST_PRE_AUTH_VIEW : TPA_DB_TAG_LIST_CLAIM_VIEW)  : TPA_DB_TAG_LIST_NAME;

  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/TPAHospitalStatusClaimCount`;
    let tagListRequest: any = {
      tpaStatusList: selectedList?.map(({ id }: any): string => id),
    };
    let centerIdListArray;
    const { dateFilter } = filters;
    const finalFilters = {
      ...filters,
      dateFilter: (Array?.isArray(dateFilter) && dateFilter?.length > 0)
        ? dateFilter
        : DEFAULT_DATE_FILTER,
    };

   if  (filters['providerId']?.length > 0) {
       centerIdListArray = filters['providerId'].map((ele: string): number => Number(ele));

          // adding a list of selected centerIds for fetching the claims count on filtering
      tagListRequest = {
        ...tagListRequest,
          CenterIdList: centerIdListArray,
        };
      }
      const startDate = combineDateAndTime(showTpaStartDateAndTime?.date, showTpaStartDateAndTime?.time);
      const endDate = combineDateAndTime(showTpaEndDateAndTime?.date, showTpaEndDateAndTime?.time);
      const convertedIsoDate = convertToISOStrings([startDate, endDate]);
      // Check if PreAuthClaimView is enabled
      if (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) {
        tagListRequest = {
          ...tagListRequest,
          tpaStatusList: [], // Clear the tpaStatusList
          filters: filterDateFilterOnly(formatSelectedFilter(finalFilters)),
          startDate: convertUtcToIst(convertedIsoDate?.[0]),
          endDate: convertUtcToIst(convertedIsoDate?.[1]),
            isNewTpaDeskEnabled,
            viewType: isPreAuthView ? 'PreAuthView' : 'ClaimView', // Set viewType based on isPreAuthView

        };
      }

    const { isSuccess, claimCountDtails, totalSecondClaimCountDetails, bucketedData }: any =
     yield SendRequest.instance.post(url, tagListRequest);
    if (isSuccess) {
      getTpaTagListCount((isPreAuthClaimViewEnabled && isNewTpaDeskEnabled ) ? bucketedData : claimCountDtails);
      getTagFilterCount(totalSecondClaimCountDetails);
    }
  } catch (e) {

  }
}
function filterValues(): { key: string, value: string[] }[] {
  const valuesToFilter = [
    '2',
    '8',
    '10',
    '11',
    '12',
    '14',
    '15',
    '31',
    '4',
    '37',
  ];
  const filters = [{
    key: 'statusId',
    value: valuesToFilter,
  }];
  return filters;
}

function* fetchInPatientList({ payload }: any): Generator {
  const { getInPatientList, isReimbursement: isReimbursementClaim = false } = payload;
  const sendRequest = SendRequest.instance;
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const {
    filters,
    globalSearch: searchedValue,
    filterAction,
    sortingKey,
    pageIndex,
    isNextStatus,
    nextStatusFilters,
    tpaNextStatus,
    timeFilter: timeFlter,
    tpaSecondaryFilter: tpaSecondoryFilter,
    isCourierClicked,
    badRequestCount,
    isPreAuthView,
    isInitiateSettelmentBtnClicked,
    tpaDeskSecondaryFilter,
    showTpaStartDateAndTime,
    showTpaEndDateAndTime,
    tpaGlobalSearchClicked,
  }: any = yield select(
    (state: RootState): any => state.selectedInPatientDetail,
  );
  const groupProviders = appDetail.getGroupProviders();
  const { payerList: { allPayers = {} } }: any = yield select((state: RootState): any => state);
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();

  let request: any = {
    isReimbursementClaim,
    isTPADashboard: process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true' ?
      true : groupProviders?.length > 0 ? false : true, // disabling-3690-on-prod
    payerId: 99999,
    providerId: appDetail.getProviderId(),
    range: INPATIENT_LIST_PAGERANGE,
    startIndex: (pageIndex !== undefined && pageIndex !== null) ? pageIndex : 1,
  };
  let centerIdListArray;
  if (filters['providerId']?.length > 0) {
    centerIdListArray = filters['providerId'].map((ele: string): number => Number(ele));
    // adding a list of selected centerIds for fetching the claims count on filtering
    request = {
      ...request,
      CenterIdList: centerIdListArray,
    };
  }
  const searchKey = String(searchedValue);
  if (searchKey) {
    if (isPreAuthView && isPreAuthClaimViewEnabled) {
      request = {
        ...request,
      };
    } else {
      request['utrNo'] = searchedValue;
    }
  }

  if (filterAction !== 'All' && !isNextStatus) {
    request.action = filterAction;
  } else {
    delete request.action;
  }
  if (isNextStatus && (!isPreAuthClaimViewEnabled && !isNewTpaDeskEnabled)) {
    request.nextStatus = nextStatusFilters;
  } else {
    delete request.nextStatus;
  }
  const { dateFilter } = filters;
    const finalFilters = {
      ...filters,
      dateFilter: (Array?.isArray(dateFilter) && dateFilter?.length > 0)
        ? dateFilter
        : DEFAULT_DATE_FILTER,
    };

  let selectedFilters;
  if (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) {
    selectedFilters = formatSelectedFilter(finalFilters);
  } else {
    selectedFilters = formatSelectedFilter(filters);
  }

  selectedFilters?.forEach((obj: any): any => {
    if (obj?.key === 'payerId') { // add payer id's of payers with similiar to shortname
      // for payers whcih are converting to NHCX and its an RPA payer as well
      const filteredKeys = new Set<string>();

      obj.value?.forEach((key: string): any => {
        const targetObject = allPayers?.find((payer: any): any => payer?.key === key);

        if (targetObject?.shortName) {
          const targetShortName = targetObject?.shortName;
          // Filter allPayers based on targetShortName
          const filteredObjects = allPayers?.filter((payer: any): any => payer?.shortName === targetShortName);
          filteredObjects?.forEach((payer: any): any => {
            filteredKeys?.add(payer?.key);
          });
        } else {
          filteredKeys?.add(key);
        }
      });
      obj.value = Array?.from(filteredKeys);
    }
  });
  if (selectedFilters?.length > 0) {
    request = {
      ...request,
      filters: selectedFilters,
    };
  }

  yield put(setViewCounts({ 'preAuthViewClaimCount': 0, 'claimViewClaimCount': 0 }));
  request.isSearchEnabled = (searchKey) || selectedFilters.length > 0 ? true : false;
  if (process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true' && centerIdListArray?.length > 0) {
    request.isSearchEnabled = false; // incase of group centers when centers is selected
  }
  if (sortingKey) {
    request = {
      ...request,
      sortingKey,
    };
  }

  if (tpaNextStatus) {
    request = {
      ...request,
      tpaNextStatus,
    };
  }

  if (isCourierClicked) {
    const statusFilters = filterValues();
    request = {
      ...request,
      isCourierClicked,
      filters: [...selectedFilters, ...statusFilters],  // IPP-5103 bugfix
    };
  }
  if (timeFlter) {
    request = {
      ...request,
      timeFlter,
    };
  }

  if (tpaSecondoryFilter) {
    request = {
      ...request,
      tpaSecondoryFilter,
    };
  }
  if (tpaDeskSecondaryFilter && (isNewTpaDeskEnabled && isPreAuthClaimViewEnabled)) {
    request = {
      ...request,
      tpaDeskSecondaryFilter,
    };
  }
  if (isInitiateSettelmentBtnClicked) {
    request = {
      ...request,
      tpaNextStatus: isNewTpaDeskEnabled ? 'AWAITING_SETTLEMENT' : 'AWAITINGSETTLEMENT', // different string used for new TPA desk feature
      timeFlter: 'All',
    };
  }
  if (isPreAuthClaimViewEnabled) {
    const startDate = combineDateAndTime(showTpaStartDateAndTime?.date, showTpaStartDateAndTime?.time);
    const endDate = combineDateAndTime(showTpaEndDateAndTime?.date, showTpaEndDateAndTime?.time);
    const convertedIsoDate = convertToISOStrings([startDate, endDate]);
    request = {
      ...request,
      viewType: isPreAuthView ? 'PreAuthView' : 'ClaimView',
      ...((isNewTpaDeskEnabled && isPreAuthClaimViewEnabled) && {
        startDate: convertUtcToIst(convertedIsoDate?.[0]),
        endDate: convertUtcToIst(convertedIsoDate?.[1]),
        isGlobalSearch: tpaGlobalSearchClicked,
    }),
      isNewTpaDeskEnabled,
    };

  } else {
    request = {
      ...request,
      viewType: 'DefaultView',
    };
  }

  try {
    const response: any = yield sendRequest.postHomepage(`${GLOBAL_URL.CRM_BASE_URL}${INPATIENT_DATA}`, request,
      { isShowErrorInInterceptor: false });
      getInPatientList(response);
      yield put(setBadRequestCount(0));
      yield put(setTpaGlobalSearchClicked(false));
  } catch (e) {
    yield put(setBadRequestCount(badRequestCount + 1));
    yield put(setTpaGlobalSearchClicked(false));
    getInPatientList({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}

function* fetchTotalPayerCount({ payload }: any): Generator {
  const { getTotalCountList } = payload;
  const sendRequest = SendRequest.instance;
  const {payerList: { allPayers = {} }}: any = yield select((state: RootState): any => state);
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const {
    badRequestCount,
  }: any = yield select((state: RootState): any => state.selectedInPatientDetail);
  const request = {
    providerId: appDetail.getProviderId(),
    payerIDs : allPayers.filter((e: any): any => !e?.isGovtScheme).map((e: any): any => e?.id),
    productCodes : allPayers.filter((e: any): any => e?.isGovtScheme).map((e: any): any => e?.productCode),
  };
  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.CRM_BASE_URL}Provider/Search/ClaimsCount`, request,
      { isShowErrorInInterceptor: false });
    getTotalCountList(response);
    if (!response?.isSuccess) {
      yield put(setBadRequestCount(0));
    }
  } catch (e) {
    yield put(setBadRequestCount(badRequestCount + 1));
    getTotalCountList({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}

export function* saveInPatientConfiguration({
  payload: { payload, setIsVisible, configType, isDisplayName },
}: any): Generator {
  const updatedConfig = isDisplayName ? prepareConfigForDisplayNameUpload(payload) : prepareConfigForUpload(payload);
  const appDetail: any = yield select(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/EditUser`;
  const sendRequest = SendRequest.instance;
  const userProps = {
    [tableConfigKeyMap[configType] || 'InPatientSearchParamList']: JSON.stringify(updatedConfig),
  };

  const request = {
    providerId: appDetail.getProviderId(),
    userProperties: userProps,
  };
  try {
    const { isSuccess, errors }: any = yield sendRequest.post(url, request, {
      isShowErrorInInterceptor: false,
    });
    if (isSuccess) {
      centeredNotification('Preferences saved successfully.', 'success');
    } else {
      centeredNotification(errors?.join('\n') || PREFERENCE_SAVE_FAIL_ERR);
    }
  } catch (e) {
    centeredNotification(PREFERENCE_SAVE_FAIL_ERR);
  } finally {
    // Map configType → Redux action
    const actionMap: Record<string, any> = {
      reportingTransactionConfigList: updateReportingConfig,
      claimsDisplay: updateClaimsDisplayConfig,
      reconciliation: updateReconciliationIpConfig,
      grievance: updateIpConfig,
      viewGrievance: updateGrievanceConfig,
      preAuthView: updateIpConfigPreAuthViewConfig,
      claimView: updateIpConfigClaimViewConfig,
      inPatient: updateIpConfig,
      reportingTATConfigList: updateTatReportingConfig,
    };

    const updateAction = actionMap[configType] || updateIpConfig;
    yield put(updateAction(updatedConfig));

    // save updated user details
    const updatedUserDetail = appDetail.getUserDetail();
    localStorage.setItem('userDetail', encryptText(JSON.stringify(updatedUserDetail)));
    setIsVisible(false);
  }
}

function* bulkUploadClaimsSaga ({payload}: any): Generator {
  const {
    bulkUploadPayload,
    callBackFunction,
  } = payload;

  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/UpdateCourierService`;
  const sendRequest = SendRequest.instance;

  try {
    const { isSuccess, errors }: any = yield sendRequest.post(url, bulkUploadPayload, { isShowErrorInInterceptor: false });
    if (isSuccess) {
      callBackFunction();
      centeredNotification('Courier details successfully updated to the claims selected.', 'success');
    } else {
      centeredNotification(errors.join('\n') || COMMON_ERROR);
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}
function* fetchTodaysClaims({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  const { requestPayload, onSuccess, onError } = payload;
  try {
    const response: any = yield sendRequest.postHomepage(`${GLOBAL_URL.CRM_BASE_URL}${INPATIENT_DATA}`, requestPayload,
      { isShowErrorInInterceptor: false });
    if (response.isSuccess && response.claimDetails !== undefined) {
      onSuccess(response.claimDetails, response?.count);
    } else {
      onError();
    }
  } catch (e) {
    onError();
  }
}

function* fetchFollowUpDetails({ payload }: any): Generator {
  const sendRequest: any = yield SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(
      `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/FollowUpDetails`,
      payload,
      defaultPostParams.defaultConfig,
      defaultPostParams.defaultHeaders,
      defaultPostParams.defaultIsProviderInfoRequired,
      defaultPostParams.defaultIsBadRequest,
      true, // to use the providerId from the payload
    );
    if (response.isSuccess) {
      yield put(setFollowUpDetails(response));
    } else {
      yield put(setFollowUpDetails({}));
    }
  } catch (error) {
    centeredNotification(COMMON_ERROR);
  }
}

function* followUpConfirmation({ payload }: any): Generator { // when we click on send button on follow up modal
  const { followUpDetailsPayload }: any = yield select(
    (state: RootState): any => state.selectedInPatientDetail,
  );
  const sendRequest: any = yield SendRequest.instance;
  const {onSuccess, onFailure, followUpEmailPayload} = payload;
  const requestPayload = {
    ...followUpDetailsPayload,
    ...followUpEmailPayload,
  };
  try {
    const response: any = yield sendRequest.post(
      `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/SendFollowUpReminder`,
      requestPayload,
      defaultPostParams.defaultConfig,
      defaultPostParams.defaultHeaders,
      defaultPostParams.defaultIsProviderInfoRequired,
      defaultPostParams.defaultIsBadRequest,
      true,  // to use the providerId from the payload
    );

    if (response.isSuccess) {
      onSuccess();
   } else {
      onFailure();
    }
  } catch (error) {
    onFailure();
  }
}

export function* watchInPatientAction(): any {
  yield takeLatest(actionTypes.FETCH_INPATIENT_LIST, fetchInPatientList);
  yield takeLatest(actionTypes.SAVE_IN_PATIENT_CONFIG, saveInPatientConfiguration);
  yield takeLatest(actionTypes.FETCH_TAGLIST_COUNT, fetchTagListCount);
  yield takeLatest(actionTypes.BULK_UPLOAD_CLAIMS, bulkUploadClaimsSaga);
  yield takeLatest(actionTypes.FETCH_TOTAL_COUNT_LIST, fetchTotalPayerCount);
  yield takeLatest(actionTypes.FETCH_TODAYS_CLAIMS, fetchTodaysClaims);
  yield takeLatest(actionTypes.FETCH_FOLLOWUP_DETAILS, fetchFollowUpDetails);
  yield takeLatest(actionTypes.FOLLOW_UP_CONFIRMATION, followUpConfirmation);
}

export default watchInPatientAction;
